import InletAirConfiguration from './InletAirConfiguration';
import inletAirValidation, { defaultInletAirConfig } from './inletAirValidation';

export { inletAirValidation, defaultInletAirConfig };
export default InletAirConfiguration;
